// ProfileDetailForm.tsx
import {Button} from 'primereact/button'
import {Divider} from 'primereact/divider'
import {Dropdown} from 'primereact/dropdown'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import React, {useState} from 'react'
import {ReactComponent as PencilIcon} from '../../../src/assets/icons/Pencil.svg'
import {ReactComponent as XmarkIcon} from '../../../src/assets/icons/XMark.svg'
import TranslateUtils from '../../i18n/TranslateUtils'
import {component} from '../form/Constant'
import {patientKeys, patientOptionsList} from '../patient/PatientConstants'

const ProfileDetailForm = ({data = {}, onChange = () => {}}) => {
    const {translateKeys} = TranslateUtils()
    const [editField, setEditField] = useState(null)
    const [tempValue, setTempValue] = useState('')
    const [isCancelling, setIsCancelling] = useState(false)

    const formFields = [
        {
            key: patientKeys.title,
            label: 'Title',
            component: component.dropdown,
            options: patientOptionsList.title,
        },
        {
            key: patientKeys.firstName,
            label: 'First Name',
            component: component.inputText,
        },
        {
            key: patientKeys.lastName,
            label: 'Last Name',
            component: component.inputText,
        },
        {
            key: patientKeys.email,
            label: 'Email',
            component: component.inputText,
        },
        {
            key: patientKeys.gender,
            label: 'Gender',
            component: component.dropdown,
            options: patientOptionsList.gender,
        },
        {
            key: patientKeys.dob,
            label: 'Date of Birth',
            component: component.inputMask,
            placeholder: 'DD-MM-YYYY',
        },
    ]

    const startEdit = fieldKey => {
        setIsCancelling(false)
        setEditField(fieldKey)
        setTempValue(data[fieldKey] || '')
    }

    const saveEdit = fieldKey => {
        onChange({...data, [fieldKey]: tempValue})
        setEditField(null)
    }

    const cancelEdit = () => {
        setIsCancelling(true)
        setEditField(null)
        setTempValue('')
    }
    const renderInput = item => {
        const handleKeyDown = e => {
            if (e.key === 'Enter') {
                e.preventDefault()
                if (!isCancelling) saveEdit(item.key)
            }
            if (e.key === 'Escape') {
                e.preventDefault()
                cancelEdit()
            }
        }

        switch (item.component) {
            case component.inputText:
                return (
                    <InputText
                        value={tempValue}
                        onChange={e => setTempValue(e.target.value)}
                        className="w-full"
                        onBlur={() => {
                            if (!isCancelling) saveEdit(item.key)
                        }}
                        onKeyDown={handleKeyDown}
                    />
                )
            case component.inputMask:
                return (
                    <InputMask
                        value={tempValue}
                        onChange={e => setTempValue(e.value)}
                        mask="99-99-9999"
                        slotChar="DD-MM-YYYY"
                        className="w-full"
                        onBlur={() => {
                            if (!isCancelling) saveEdit(item.key)
                        }}
                        onKeyDown={handleKeyDown}
                    />
                )
            case component.dropdown:
                return (
                    <Dropdown
                        value={tempValue}
                        options={item.options}
                        optionLabel="label"
                        optionValue="value"
                        onChange={e => setTempValue(e.value)}
                        onHide={() => {
                            if (!isCancelling) saveEdit(item.key)
                        }}
                        className="w-full"
                    />
                )
            default:
                return null
        }
    }

    return (
        <div id="" className="profile-detail-container">
            {formFields.map(item => (
                <React.Fragment key={item.key}>
                    {' '}
                    <div className="profile-row">
                        <div className="profile-label font-semibold">
                            {translateKeys(item.label)}
                        </div>

                        <div className="profile-value">
                            {editField === item.key
                                ? renderInput(item)
                                : data[item.key] || '-'}
                        </div>

                        <div className="profile-action">
                            {editField === item.key ? (
                                <>
                                    <Button
                                        className="profile-action-icon text-primary"
                                        style={{marginRight: 8}}
                                        onMouseDown={() => {
                                            setIsCancelling(true)
                                            cancelEdit()
                                        }}
                                        icon={<XmarkIcon className="" />}
                                    />
                                </>
                            ) : (
                                <>
                                    <Button
                                        className="profile-action-icon text-primary"
                                        style={{marginRight: 8}}
                                        onMouseDown={() => {
                                            startEdit(item.key)
                                        }}
                                        icon={<PencilIcon className="" />}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    <Divider className="m-0 p-0" type="dashed" />
                </React.Fragment>
            ))}
        </div>
    )
}

export default ProfileDetailForm
